export default __webpack_public_path__ + "static/media/logInImage.be61abb2.svg";